export default __webpack_public_path__ + "static/hi_dog-ff736a0337a15ec5656ee9d89c1177cf.gif";